import { render, staticRenderFns } from "./vsChip.vue?vue&type=template&id=1756f0b2&lang=html"
import script from "./vsChip.vue?vue&type=script&lang=js"
export * from "./vsChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports